import React, { useEffect, useState, useContext } from 'react';

import { makeStyles } from '@mui/styles';
import { ButtonBase, Tooltip } from '@mui/material';

import Node from '../../../common/Node';
import Search from '../../../common/Search';

import { EventsContext } from '../EventsContext';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteForever';
import LoaderNew from '../../../common/LoaderNew';

import CommonStyles from '../../../common/CommonStyles';
import ActionConfirmation from '../../../common/ActionConfirmation';
import EventsStyles from '../EventsStyles';

import Filters from '../../../common/Filters';

const useStyles = makeStyles({
  ...CommonStyles,
  ...EventsStyles,
});

const EventByInference = (props) => {
  const { nodesData, updateEvent, deleteEvent, addNodeToNodesData, addSubscriber, removeDraftEvent } = useContext(EventsContext);
  const [saveLoading, setSaveLoading] = useState(false);
  const [editable, setEditable] = useState(false);
  const [sub, setSub] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const classes = useStyles({
    editable,
  });

  const editSub = (sub) => {
    sub.trigger.trpls = sub.trigger.trpls.filter(filter => filter.pids_chain.length);

    setSaveLoading(true);
    updateEvent(sub.subscriber, sub.type, sub, (updatedSub) => {
      setSub(JSON.parse(JSON.stringify(updatedSub)));
      setEditable(false);
      setSaveLoading(false);
    });
  };

  useEffect(() => {
    setSub(JSON.parse(JSON.stringify(props.sub)));
    if (props.sub.editable) setEditable(true);
  }, [props.sub]);

  const setFiltersToState = (filters) => {
    const subCopy = { ...sub };
    subCopy.trigger.trpls = filters;

    setSub(subCopy);
  };

  const setGraphTriggerAncestorToParentState = (graphTriggerAncestor) => {
    const subCopy = { ...sub };
    if (graphTriggerAncestor) {
      subCopy.trigger.ancestor = graphTriggerAncestor.id;
    } else subCopy.trigger.ancestor = null;

    setSub(subCopy);
  };

  const eventReturnPropsValues = () => {
    const subCopy = JSON.parse(JSON.stringify(props.sub));

    setSub(subCopy);
  };
  
  const deleteJelModal = {
    contentText: 'Delete',
    contentBoldText: `${sub && sub.id} ${sub && sub.type} event?`,
    open: showDeleteModal,
  };

  const eventIsUnsaved = sub && !sub.id;
  const node = sub && sub.subscriber && nodesData[sub.subscriber];

  return (
    <React.Fragment>
      <ActionConfirmation
        modalData={deleteJelModal}
        acceptHandler={() => {
          deleteEvent(sub.subscriber, sub.type, sub.id);
          setShowDeleteModal(false);
          setEditable(false);
        }}
        onClose={() => setShowDeleteModal(false)}
      />

      {sub !== null && (
        <div
          className={classes.row}
          id={sub.draft_id || sub.id}
          style={{maxWidth: '1000px', background: editable ? '#DBD6E5' : '#FBFBFB'}}
        >
          <div className={classes.rowContent}>
            <div style={{width: '20px', marginRight: '10px'}}>
              <span className={classes.subId}>{sub.id}</span>
            </div>
            
            <div className={classes.arrow} style={{ pointerEvents: node ? '' : 'none' }}>
              <Filters
                defaultBg={true}
                ancestor={nodesData[sub.trigger.ancestor] ? nodesData[sub.trigger.ancestor].id : null}
                callbacks={{
                  setGraphTriggerAncestorToParentState: setGraphTriggerAncestorToParentState,
                  setFiltersToParentState: setFiltersToState,
                  onFiltersSearchNodeCb: addNodeToNodesData,
                }}
                useChain
                isEvent
                nodes={nodesData}
                graphTriggerAncestor={nodesData[sub.trigger.ancestor]}
                mode={editable ? 'edit' : 'show'}
                initialFilters={sub.trigger.trpls}
              />
            </div>

            <div style={{ margin: '14px 20px'}}>
              {node ?
                <Node size="xs" isLink node={node}/>
              : 
                <Search
                  conceptsOnly={true}
                  containerStyles={{
                    height: 24,
                  }}
                  onDropdownElementClick={({ node }) => {
                    addSubscriber(node.id, sub.type, sub.draft_id);
                    addNodeToNodesData(node);
                  }}
                />
              }
            </div>

            <div className={`${classes.editRowCol} ${classes.ml20}`}>
              {!editable ? (
                <Tooltip
                  title="Edit"
                  placement="top"
                  classes={{
                    tooltip: classes.muiTooltip,
                  }}
                >
                  <EditIcon
                    onClick={() => {
                      setEditable(true);
                    }}
                  />
                </Tooltip>
              ) : null}
            </div>
          </div>

          {editable ? (
            <div className={classes.rowButtonsContainer}>
              {!eventIsUnsaved ? (
                <ButtonBase
                  className={`${classes.rowActionBtn} ${classes.btn} ${classes.btnEmpty} ${classes.mr10}`}
                  onClick={() => {
                    setShowDeleteModal(true);
                  }}
                >
                  <span>Delete</span>

                  <DeleteIcon className={classes.deleteRowIcon} />
                </ButtonBase>
              ) : <div />}

              <div className={classes.alignCenter}>
                <ButtonBase
                  className={`${classes.rowActionBtn} ${classes.btn} ${classes.btnEmpty} ${classes.mr10}`}
                  onClick={() => {
                    eventReturnPropsValues();
                    setEditable(false);

                    // unsaved events shouldn't be in events list after editing
                    if (eventIsUnsaved) {
                      if (sub.subscriber) {
                      deleteEvent(sub.subscriber, sub.type, sub.draft_id);
                      } else removeDraftEvent(sub.type);
                    }
                  }}
                >
                  Cancel
                </ButtonBase>
                <ButtonBase
                  disabled={
                    !node
                    || !sub.trigger.ancestor
                    || (sub.trigger.trpls && !sub.trigger.trpls.length)
                    || (sub.trigger.trpls.length && sub.trigger.trpls[0].pids_chain && !sub.trigger.trpls[0].pids_chain.length)}
                  className={`${classes.rowActionBtn} ${classes.btn} ${classes.btnNormal}`}
                  classes={{
                    disabled: classes.saveBtnDisabled,
                  }}
                  onClick={() => {
                    if (!sub.entityType) sub.entityType = 102;
                    editSub(sub);
                  }}
                >
                  {saveLoading ? <LoaderNew /> : 'Save'}
                </ButtonBase>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </React.Fragment>
  );
};

export default (EventByInference);
